import { forwardRef, memo, MouseEventHandler } from "react";
import classnames from "classnames";

import { ReactComponent as Hide } from "./icons/hide.svg";
import { ReactComponent as Show } from "./icons/show.svg";

import styles from "./style.module.scss";

type EyeButtonProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>,
  disabled?: boolean,
  isShownPassword?: boolean
}

export const EyeButton = memo<EyeButtonProps>(forwardRef<HTMLButtonElement, EyeButtonProps>((
  { isShownPassword, ...props }, ref) =>
  (
    <button
      ref={ref}
      className={classnames(styles.eyeBtn)}
      type="button"
      {...props}
    >
      {isShownPassword ? <Show /> : <Hide />}
    </button>
  )));


